import { createSlice } from '@reduxjs/toolkit';
import { ResourceDataVariableName } from '../../common/commonHelper';

import { ApiURLs, API_BASE_URL } from '../../common/url';

import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
  resource: undefined,
}

export const getResourceData = AsyncThunkAction('data/resource', API_BASE_URL + ApiURLs.Resource.getResource)

const resourceSlice = createSlice({
  name: 'resource',
  initialState: initialState,
  reducers: {
    // setResourceData: (state, action) => {
    //   state.resource = action.payload.data
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResourceData.pending, (state, action) => {
      })
      .addCase(getResourceData.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.resource = action.payload.data.resource
          window[ResourceDataVariableName] = action.payload.data.resource;
        }
      }).addCase(getResourceData.rejected, (state, action) => {
      })
  }
})

export default resourceSlice.reducer